import React from "react";
import styles from "./Loan.module.css";
import SaveBtn from "../../Buttons/SaveBtn";
import finance from "../../../assets/images/finance.svg";
import domestic from "../../../assets/images/domestic.svg";
import abroad from "../../../assets/images/abroad.svg";

const NewApplication = () => {
  return (
    <div className={styles.loanContainer}>
      <div className={styles.row}>
        <div className={styles.column}>
          <div>Education Fee Finance</div>
          <div style={{ margin: "10px 0px" }}>
            <img src={finance} />
          </div>
          <div>
            <SaveBtn buttonText="Apply" />
          </div>
        </div>
        <div className={styles.column}>
          <div>Higher Education Loan Domestic</div>
          <div style={{ margin: "10px 0px" }}>
            <img src={domestic} />
          </div>
          <div>
            <SaveBtn buttonText="Apply" />
          </div>
        </div>
        <div className={styles.column}>
          <div>Higher Education Loan Abroad</div>
          <div style={{ margin: "10px 0px" }}>
            <img src={abroad} />
          </div>
          <div>
            <SaveBtn buttonText="Apply" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewApplication;
